import $ from 'jquery';
import { CoverageService  } from '../../services/coverageService';
import { connectEventToState, eventListeners } from '../../react-features/sidebar-coverage/connectEventToState';
import { store } from '../../react-features/sidebar-coverage/redux/store';
import { actionCreators } from '../../react-features/sidebar-coverage/redux/actions';

const activeClass: string = 'js-active';
const service: CoverageService = new CoverageService();
let selectedCoverage: number;

export const initialize = () => wireClickEvent();

const wireClickEvent = () => $('.js-watch').on('click', handleClick);

const deleteCoverageEvent = connectEventToState.create(eventListeners.deleteCoverage, document.querySelector('.js-watch')!, (event) => {
  event && event.preventDefault();

  if (selectedCoverage) {
    store.dispatch(actionCreators.deleteCoverage(selectedCoverage))
  }
})

const addCoverageEvent = connectEventToState.create(eventListeners.addCoverage, document.querySelector('.js-watch')!, (event) => {
  event && event.preventDefault();

  if (selectedCoverage) {
    store.dispatch(actionCreators.toggleTooltip());
    service.getCoverages(res => {
      store.dispatch(actionCreators.setAllCoverages(res))
    }, res => console.error(res))
}})

const handleClick = (e: JQuery.TriggeredEvent) => {
  e.preventDefault();

    const $this = $(e.currentTarget);
    const isActive = $this.hasClass(activeClass);
    const contentId = e.currentTarget.dataset.contentid;
    const pageName = e.currentTarget.dataset.pagetitle;
  
  if (isActive) {
    service.deleteCoverageById(contentId, res => {
      $this.removeClass(activeClass);
      $this.find(".button-text").text("Bevaka");
      const pageId = parseInt(contentId, 10);

      if (pageId) {
        selectedCoverage = pageId;
        document.querySelector('.js-watch')!.dispatchEvent(deleteCoverageEvent);
      }
    }, () => alert('Tillfälligt fel: Kan inte ta bort bevakning'));
  } else {
    service.addCoverage(contentId, pageName, res => {
      $this.addClass(activeClass);
      $this.find(".button-text").text("Bevakar");
      if (res) {
        selectedCoverage = res;
        const pageId = parseInt(contentId, 10);
  
        if (pageId) {
          selectedCoverage = pageId;
          document.querySelector('.js-watch')!.dispatchEvent(addCoverageEvent);
        }
      }
    }, () => alert('Tillfälligt fel: Kan inte skapa bevakning'));    
  }
  $this.blur();
}